import {UserOPEEnum} from "./UserOPEEnum";
import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";

class UserDTO {
  public id!: number;
  public username!: string;
  public email!: string;
  public firstname!: string;
  public lastname!: string;
  public language?: string;
  public roles?: string[];
  public partitionId!: number;
  public partitionName!: string;
  public enabled!: boolean;
  linkedPartitions?: number[];
  welcomeSent!: boolean;

}

class O {
  users!: UserDTO[];
}

/**
 * O Inner Class
 */
class I {
  partitionId!: number;
}


/**
 * GetTransportItemDetailCB class
 */
export class GetUsersCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(UserOPEEnum.GetUsers);
    this.i = new I();
    this.o = new O();
  }

}
